import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FormikCheckboxGroupItem } from '../../../../../../../../components/FormikFields'

const propTypes = {
  licenses: PropTypes.arrayOf(PropTypes.object), // eslint-disable-line react/forbid-prop-types
}

function AddUserLicenseTab({ licenses = [] }) {
  return (
    <>
      <div className="text-strong mb-4">
        <FormattedMessage id="ENGAGE.ASSIGN_LICENSES" />
      </div>
      <div className="ms-3 me-3">
        {licenses.map((license) => (
          <FormikCheckboxGroupItem
            name="licenses"
            id={license?.id}
            key={license?.id}
            className="checkbox-left-aligned"
            label={<span className="font-bolder">{license?.displayName}</span>}
          />
        ))}
      </div>
    </>
  )
}

AddUserLicenseTab.propTypes = propTypes

export default AddUserLicenseTab
